<template>
  <onboarding-step>
    <template #content>
      <div class="grid gap-8">
        <div class="grid gap-3">
          <div class="text-2xl sm:text-3xl font-serif font-medium text-blue dark:text-white">
            What's your highest LSAT?
          </div>
          <div class="text-gray-600 lg:text-lg">
            We use this to determine your chances of admission for each school.
          </div>
          <l-lsat-input
            v-model="user.lsat"
            class="label:sr-only help:sr-only"
            size="lg"
          />
        </div>
        <div class="grid gap-3">
          <div class="text-2xl sm:text-3xl font-serif font-medium text-blue dark:text-white">
            What's your LSAC CAS GPA?
          </div>
          <div class="text-gray-600 lg:text-lg">
            The
            <a class="font-medium" href="https://www.lsac.org/applying-law-school/jd-application-process/cas/requesting/transcript-summarization">
              CAS GPA
            </a>
            is what matters in law school admissions.
            Because of the wide range of grading systems, LSAC converts your GPA into a standard format
            that takes into account all your undergraduate coursework.
          </div>

          <l-gpa-input
            v-model="user.gpa"
            class="label:sr-only help:sr-only"
            size="lg"
          />
        </div>
      </div>
    </template>
    <template #subcontent>
      <img src="/images/illustration-sitting-1.svg" class="h-full w-auto py-16">
    </template>
  </onboarding-step>
</template>

<script setup>
import LGpaInput from "@/components/inputs/LGpaInput.vue"
import LLsatInput from "@/components/inputs/LLsatInput.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"

const user = defineModel({ type: Object, required: true })
</script>
